

export let template = {
    list: [
        { name: '模板（默认）', image: '/template_default.png', template: 'default', },
        { name: '模板1', image: '/template_1.png', template: 'template1', },
        { name: '模板2', image: '/template_2.png', template: 'template2', },
        { name: '模板3', image: '/template_3.png', template: 'template3', },
    ]
}